import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=0ea0d4ba&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea0d4ba')) {
      api.createRecord('0ea0d4ba', component.options)
    } else {
      api.reload('0ea0d4ba', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=0ea0d4ba&", function () {
      api.rerender('0ea0d4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-49pmXpk2rXZLV/JS/ImageCarousel.vue"
export default component.exports